import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getPendingWizardForm, getWizardForm } from 'services/product';

import { wizardFormKeys } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/hooks/queryKeys';
import { useCallback } from 'react';

export const useGetWizardForm = (params, options = {}) => {
  return useQuery({
    queryKey: wizardFormKeys.detail(params?.wizardFormId),
    queryFn: () => getWizardForm(params),
    enabled: !!params,
    ...options,
  });
};

export const useGetPendingWizardForm = (options = {}) => {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: wizardFormKeys.pending(),
    queryFn: getPendingWizardForm,
    ...options,
  });

  const prefetchPendingWizard = useCallback(async () => {
    return queryClient.prefetchQuery({
      queryKey: wizardFormKeys.pending(),
      queryFn: getPendingWizardForm,
    });
  }, [queryClient]);

  const fetchPendingWizard = useCallback(() => {
    return queryClient.fetchQuery({
      queryKey: wizardFormKeys.pending(),
      queryFn: getPendingWizardForm,
    });
  }, [queryClient]);

  return {
    ...query,
    prefetchPendingWizard,
    fetchPendingWizard,
  };
};
